var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[[_c('v-card',{attrs:{"flat":""}},[_c('v-toolbar',{attrs:{"color":"primary","dark":"","extended":"","flat":""}}),_c('v-card',{staticClass:"mx-auto",staticStyle:{"margin-top":"-64px"},attrs:{"max-width":"1280","color":"grey lighten-1"}},[_c('router-view')],1)],1)]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }